import React from "react";

type Props = { className?: string; size?: number };

const ProfileIcon: React.FC<Props> = ({ className, size = 20 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    className={className}
    aria-hidden="true"
  >
    <path
      stroke="#9F9FA6"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9.987 12.789c-3.223 0-5.975.487-5.975 2.438 0 1.952 2.735 2.457 5.975 2.457 3.223 0 5.975-.488 5.975-2.44 0-1.95-2.734-2.455-5.975-2.455Z"
      clipRule="evenodd"
    />
    <path
      stroke="#9F9FA6"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.429}
      d="M9.987 10.005a3.83 3.83 0 1 0-3.83-3.83 3.817 3.817 0 0 0 3.803 3.83h.027Z"
      clipRule="evenodd"
    />
  </svg>
);

export default ProfileIcon;
